<script setup>
import {computed} from 'vue';

/**
 * Định nghĩa props cho chart
 */
const props = defineProps({
  name: String,
  data: Array,
  title: String,
  options: Object,
});

// Build series và option cho chart
const series = computed(() => {
  return props.data;
});
const chartOptions = computed(() => {
  return {
    chart: {
      type: 'donut',
    },
    ...props.options.customOptions,
  };
});
</script>
<template>
  <apexchart type="donut" :options="chartOptions" :series="series"></apexchart>
</template>
